import React, { useState } from "react";
import "./Register.css";
import registerbg from "../../assets/register-bg.png";
import logo from "../../assets/logo.png";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl } from "../../App";
import BuyerServicesUrl from "../../BuyerServicesUrl";
import { useRef, useMemo } from "react";
import { defaultCountries, parseCountry, FlagImage } from "react-international-phone";
import "react-international-phone/style.css";


export default function Register() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [country, setCountry] = useState("");
  const [code, setCode] = useState("+20");
    const [referralCode, setReferralCode] = useState("");

  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [city, setCity] = useState("");
const [address, setAddress] = useState("");

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [apiError, setApiError] = useState("");
const [showSuccess, setShowSuccess] = useState(false);
const [showError, setShowError] = useState(false);
const [userType, setUserType] = useState("customer"); // customer 
const [profileImage, setProfileImage] = useState(null);
const [commercialRegister, setCommercialRegister] = useState(null);

const [activityType, setActivityType] = useState("");
const [countBranches, setCountBranches] = useState("");
const [area, setArea] = useState("");
const [period, setPeriod] = useState("");

const [linkFacebook, setLinkFacebook] = useState("");
const [linkWhatsapp, setLinkWhatsapp] = useState("");
const [linkInsta, setLinkInsta] = useState("");
const [linkSnab, setLinkSnab] = useState("");
  const dropdownRef = useRef(null);

const countries = useMemo(
  () => defaultCountries.map(parseCountry),
  []
);

const [isOpen, setIsOpen] = useState(false);
const [selectedIso2, setSelectedIso2] = useState("eg");
  
  // const passwordRegex = /^\d{9}$/;


//   const validate = () => {
//     let temp = {};
//     if (!username.trim()) temp.username = "اسم المستخدم مطلوب";

//     const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     // if (!emailPattern.test(email)) temp.email = "البريد الإلكتروني مطلوب ";
//     if (!email.trim()) {
//   temp.email = "البريد الإلكتروني مطلوب";
// } else if (!emailPattern.test(email)) {
//   temp.email = "يرجى إدخال بريد إلكتروني صالح";
// }

//     if (!country) temp.country = "يرجى اختيار الدولة";

//     if (!phone) temp.phone = "رقم الجوال مطلوب";
//     if (phone && (phone.length < 7 || phone.length > 12))
//       temp.phone = " يرجى ادخال رقم هاتف صحيح";

// //  if (!password.trim()) {
// //   temp.password = "كلمة المرور مطلوبة";
// // } else if (!passwordRegex.test(password)) {
// // temp.password = "يجب ألا تقل كلمة المرور عن 6 أحرف ";
// // }
// if (!password.trim()) {
//   temp.password = "كلمة المرور مطلوبة";
// } else if (password.length < 6) {
//   temp.password = "يجب ألا تقل كلمة المرور عن 6 أحرف";
// }

//     if (!country) temp.country = "    الدولة مطلوبة" ;
//     if (!city.trim()) temp.city = "المدينة مطلوبة";
//     if (!address.trim()) temp.address = "العنوان مطلوب";


//     setErrors(temp);
//     return Object.keys(temp).length === 0;
//   };
const validate = () => {
  let temp = {};

  if (!username.trim()) temp.username = "اسم المستخدم مطلوب";

  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!email.trim()) {
    temp.email = "البريد الإلكتروني مطلوب";
  } else if (!emailPattern.test(email)) {
    temp.email = "يرجى إدخال بريد إلكتروني صالح";
  }

  if (!country.trim()) temp.country = "الدولة مطلوبة";
  if (!phone.trim()) temp.phone = "رقم الجوال مطلوب";
  if (phone && (phone.length < 7 || phone.length > 12)) {
    temp.phone = "يرجى إدخال رقم هاتف صحيح";
  }

  if (!password.trim()) {
    temp.password = "كلمة المرور مطلوبة";
  } else if (password.length < 6) {
    temp.password = "يجب ألا تقل كلمة المرور عن 6 أحرف";
  }

  if (!city.trim()) temp.city = "المدينة مطلوبة";
  if (!address.trim()) temp.address = "العنوان مطلوب";

 

  setErrors(temp);
  return Object.keys(temp).length === 0;
};

  
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;

//     setLoading(true);
//     setApiError("");

//     try {
//       const response = await axios.post(
//         BaseUrl + BuyerServicesUrl.Register,
//         {
//           type: "customer",
//           username,
//           email,
//           country,
//           code_phone: code.replace("+", ""),
//           phone,
//           password,
//         }
//       );

//       console.log("REGISTER SUCCESS", response.data);
//       // navigate("/login");
// setShowSuccess(true);
//     } catch (error) {
//       console.log(error.response?.data);
//        setApiError("تحقق من الحقول وحاول مرة أخرى");
//       // setApiError(error.response?.data?.message || "فشل إنشاء الحساب");
// setShowError(true);
//     } finally {
//       setLoading(false);
//     }
//   };
const handleSubmit = async (e) => {
  e.preventDefault();
  if (!validate()) return;

  setLoading(true);
  setApiError("");

  try {
    const formData = new FormData();

    formData.append("type", userType);
    formData.append("username", username);
    formData.append("email", email);
    formData.append("country", country);
    formData.append("code_phone", code.replace("+", ""));
    formData.append("phone", phone);
    formData.append("password", password);
    formData.append("city", city);
    formData.append("location", address);

    if (referralCode.trim()) {
      formData.append("referral_by", referralCode);
    }

    if (profileImage) {
      formData.append("image", profileImage);
    }

    // branches as array
    formData.append("branches[0]", city);

    const response = await axios.post(
      BaseUrl + BuyerServicesUrl.Register,
      formData,
      {
        headers: {
          Accept: "application/json",
        },
      }
    );

    console.log("REGISTER SUCCESS", response.data);

    const checkoutUrl = response?.data?.data?.checkout_url;

    if (checkoutUrl) {
      window.location.href = checkoutUrl;
      return;
    }

    setShowSuccess(true);
  } catch (error) {
    console.log(error.response?.data || error);

    setApiError(
      error?.response?.data?.data ||
      error?.response?.data?.message ||
      "تحقق من الحقول وحاول مرة أخرى"
    );

    setShowError(true);
  } finally {
    setLoading(false);
  }
};
const handleFieldChange = (field, value) => {
  setErrors((prev) => ({ ...prev, [field]: "" }));
};

  return (
    <div className="registeration">
      <div className="container-fluid">
        <div className="row">
          <div className="image col-12 col-md-6 p-0">
            <img src={registerbg} alt="Register" className="login-image" />
          </div>

          <div className="form col-12 col-md-6 text-end">
            <div className="text-center mb-3 ">
              <img src={logo} alt="logo" style={{width:"80px"}} />
            </div>

           <div className="field">
  <label>اسم المستخدم</label>
  <input
    className="form-control"
    placeholder="الاسم"
    value={username}
    onChange={(e) => setUsername(e.target.value)}
  />
  {errors.username && <small className="error text-danger">{errors.username}</small>}
</div>

           <div className="field pt-3">
<label className="">رقم الجوال</label>

<div className="regphone-row">
  <div className="code-dropdown" ref={dropdownRef}>
    <button
      type="button"
      className="code-dropdown-btn"
      onClick={() => setIsOpen((v) => !v)}
    >
      <span className="code-flag">
        <FlagImage  iso2={selectedIso2} />
      </span>

      <span className="code-dial">{code}</span>

      <span className="code-arrow">▾</span>
    </button>

    {isOpen && (
      <div className="code-dropdown-menu">
        {countries.map((c) => (
          <button
            type="button"
            key={c.iso2}
            className="code-item"
            // onClick={() => {
            //   setSelectedIso2(c.iso2);
            //   setIsOpen(false);
            // }}
            onClick={() => {
  setSelectedIso2(c.iso2);
  setCode(`+${c.dialCode}`);
  setIsOpen(false);
}}
          >
            <span className="code-flag">
              <FlagImage iso2={c.iso2} />
            </span>
            <span className="code-dial">+{c.dialCode}</span>
            <span className="code-name">{c.name}</span>
          </button>
        ))}
      </div>
    )}
  </div>

<input
  className="form-control phone-number-input text-end"
  value={phone}
  onChange={(e) => {
    setPhone(e.target.value);
    handleFieldChange("phone", e.target.value);
  }}
  placeholder="ادخل رقم الجوال"
/>
</div>

{errors.phone && <small className="text-danger">{errors.phone}</small>}

           </div>
                      <div className="field pt-3">

            <label className="">البريد الإلكتروني</label>
           <input
  className="form-control"
  placeholder="البريد الإلكتروني"
  value={email}
  onChange={(e) => {
    const value = e.target.value;
    setEmail(value);

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setErrors((prev) => ({
      ...prev,
      email:
        !value.trim()
          ? "البريد الإلكتروني مطلوب"
          : !emailPattern.test(value)
          ? "يرجى إدخال بريد إلكتروني صالح"
          : "",
    }));
  }}
/>
            {errors.email && <small className="text-danger">{errors.email}</small>}
</div>
<div>

</div>
<div className="field pt-3">
    <label className=" pb-2">كلمة المرور</label>
            <div className="special-password-box">
         <input
  type={showPassword ? "text" : "password"}
  className="special-password-input"
  placeholder="كلمة المرور"
  value={password}
  onChange={(e) => {
    const value = e.target.value;
    setPassword(value);

    setErrors((prev) => ({
      ...prev,
      password:
        !value.trim()
          ? "كلمة المرور مطلوبة"
          : value.length < 6
          ? "يجب ألا تقل كلمة المرور عن 6 أحرف"
          : "",
    }));
  }}
/>
              <i
                className={`fa-regular  ${
                  showPassword ? "fa-eye" : "fa-eye-slash"
                }`}
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
            {errors.password && <small className="text-danger">{errors.password}</small>}

            {apiError && <p className="text-danger">{apiError}</p>}
            
</div>
<div className="field pt-3">
                    <label className=" mb-2">كود المسوق (اختياري)</label>
              <input className="form-control"
                value={referralCode} placeholder="########"
                onChange={(e) => setReferralCode(e.target.value)} />

              {apiError && <p className="text-danger mt-2">{apiError}</p>}
              </div>

              <div className="field pt-3">
       <div className="row ">
  {/* المدينة */}
  <div className="col-12 col-md-6  text-end">
    <label className="mb-2 fw-semibold">المدينة/المحافظة</label>
    {/* <input
      className="form-control"
      placeholder="المدينة/المحافظة"
      value={city}
      onChange={(e) => setCity(e.target.value)}
    />
    {errors.city && (
      <small className="text-danger">{errors.city}</small>
    )} */}
    <input
  className="form-control"
    placeholder="المدينة/المحافظة"
  value={city}
  onChange={(e) => {
    setCity(e.target.value);
    handleFieldChange("city", e.target.value);
  }}
/>
  {errors.city && (
      <small className="text-danger">{errors.city}</small>
    )}
  </div>
  {/* الدولة */}
  <div className="col-12 col-md-6  text-end">
    <label className="mb-2 fw-semibold">الدولة</label>
    {/* <input
      className="form-control"
      placeholder="الدولة"
      value={country}
      onChange={(e) => setCountry(e.target.value)}
    /> */}
    <input
  className="form-control"
        placeholder="الدولة"

  value={country}
  onChange={(e) => {
    setCountry(e.target.value);
    handleFieldChange("country", e.target.value);
  }}
/>
    {errors.country && (
      <small className="text-danger">{errors.country}</small>
    )}
  </div>
</div>
<div className="field">
<div className=" text-end">
  <label className=" fw-semibold">العنوان</label>
  <input
    className="form-control"
    placeholder="العنوان"
    value={address}
    onChange={(e) =>{ setAddress(e.target.value);
        handleFieldChange("address", e.target.value);
    }}
  />
  {errors.address && (
    <small className="text-danger d-block text-end">
      {errors.address}
    </small>
  )}
</div>
</div>
</div>
        
            <button
              className="btn w-100 text-white mt-3"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "جاري إنشاء الحساب..." : "إنشاء حساب"}
            </button>

            <p className="text-center mt-3">
              تملك حساب؟{" "}
              <Link className="link" onClick={() => navigate("/login")}>
                تسجيل الدخول
              </Link>
            </p>
          </div>
        </div>
      </div>
      {showSuccess && (
  <div className="success-modal-overlay">
    <div className="success-modal">
      <div className="success-icon">
        <i className="fa fa-check"></i>
      </div>

      <h3>تم بنجاح</h3>
      <p>تم إنشاء الحساب بنجاح</p>

      {/* <button
        className="success-btn"
        onClick={() => {
          setShowSuccess(false);
          navigate("/login");
        }}
      >
        تسجيل الدخول
      </button> */}
      <button
  className="success-btn"
  onClick={() => {
    setShowSuccess(false);
    navigate("/login");
  }}
>
  متابعة
</button>
    </div>
  </div>
)}
{showError && (
  <div className="error-modal-overlay">
    <div className="error-modal">

      <div className="error-icon-wrapper">
        <div className="error-icon">
          <i className="fa fa-times"></i>
        </div>
      </div>

      <h3>فشل التسجيل</h3>
      <p>{apiError || "تحقق من الحقول وحاول مرة أخرى"}</p>

      <button
        className="error-btn"
        onClick={() => setShowError(false)}
      >
        حاول مرة أخرى
      </button>

    </div>
  </div>
)}
    </div>
  );
}